import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'content-header',
  name: '内容频道头部',
  icon: '头',
  group: '信息流页面',
  description: '品牌标题、搜索入口和频道导航。',
  defaultProps: {
    brandName: '今日看点',
    subtitle: '发现身边值得关注的内容',
    showSearch: true,
    searchPlaceholder: '搜索文章、作者或话题',
    showChannels: true,
    sticky: true
  }
}
